/**
 * Which layers a map click is allowed to select from.
 *
 * Two config flags say "not this one", and both have to be honoured in the same
 * place or they disagree:
 *
 *  - `disableClicking` — the authored config.json flag for a reference layer.
 *  - `disablePopups` — what the backend sets on layers it derives and that carry
 *    no API entity behind their features. The organisation boundary is one: it
 *    is drawn from `Organisation.geometry`, and its feature has no id to look up,
 *    so a click on the outline resolved to the id "unknown" and fetched
 *    `/api/v2/media/unknown/` — a guaranteed 404. The flag was on the wire from
 *    the start and read nowhere.
 *
 * Excluding a layer here rather than bailing out inside the click handler also
 * means clicks pass THROUGH it: an entity sitting under the boundary polygon is
 * still selectable, which is the behaviour anyone would expect of an outline
 * drawn over the whole map.
 */
export interface ClickableLayerFlags {
  disableClicking?: boolean;
  disablePopups?: boolean;
}

export const isClickableLayer = (layer: ClickableLayerFlags | null | undefined): boolean =>
  !!layer && !layer.disableClicking && !layer.disablePopups;
